import React, { useState } from 'react'
import styled from 'styled-components'
import { ShoppingCart } from '@mui/icons-material'
import { AccountCircle } from '@mui/icons-material'
import { Search } from '@mui/icons-material'
import { Menu } from '@mui/icons-material'
import { Boy } from '@mui/icons-material'
import { Girl } from '@mui/icons-material'
import { ChildCare } from '@mui/icons-material'
import { Call } from '@mui/icons-material'
import { useStateValue } from './StateProvider'
import { auth } from "../firebase";
import { useHistory } from 'react-router-dom'
import { Avatar } from '@mui/material'

function AdminHeader() {
  const [show,setShow] = useState(false)
  const [reveal,setReveal] = useState(false)
  const history = useHistory();

  return (
    <Container>
      <Content>
      <LogoImage>
        <a href="/dashboard">
          <img src="https://i.ibb.co/fdPZhrt/PRODUCT-MERCHE.png" alt="logo" />
        </a>
      </LogoImage>

        <LeftMenu>
          <a href="/dashboard">Dashboard </a>
          <a href="/products">Products </a>
            <a href="/orders">Orders </a>
          <a href="/customers">Customers</a>
        </LeftMenu>

        {show?
        <PcSearch>
          <input type="search" placeholder="Search..." />
        </PcSearch>
        :null}

        <RightMenu>
          <a href="/admin-login"><Avatar sx={{"@media(max-width: 768px)": {display: "none"}}}/></a>
          <span class="menu"><Menu onClick={()=>setReveal(!reveal)} sx={{fontSize: "25px"}}/></span>
        </RightMenu>
        </Content>

        {reveal?
         <MobileMenu>
          <MenuTitle>
            <h3>Menu</h3>
          </MenuTitle>
          <MenuLink>
          <a href="/dashboard">Dashboard </a>
          <br /><br />
          <a href="/products">Products </a>
          <br /><br />
          <a href="/orders">Orders </a>
          <br /><br />
          <a href="/upload-product">Upload </a>
          <br /><br />
          <a href="/customers">Customers</a>
          <br /><br />
          <a href="/admin-login">Admin-Login</a>
            </MenuLink>
            <br /><br />
         </MobileMenu>
        :null}

    </Container>
  )
}

const Container = styled.header`
  width: 100vw;
  height: max-content;
  background: white;
  display: flex;
  position: fixed;
  flex-direction: column;
  border-bottom: 1px solid orange;

  @media(max-width: 768px) {
    height: 10vh;
    width: 100vw;
  }
`

const Content = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid orange;

  @media(max-width: 768px) {
    height: 100%;
  }
`;

const MobileMenu = styled.div`
  height: max-height;
  background: white;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  background-color: gray;
  color: white;
`;

const MenuTitle = styled.div`
  text-align: center;
  text-decoration: underline;
  h3 {
    font-family: sans-serif;
  }
`;

const MenuLink = styled.div`
  text-align: center;
  a {
    color: white;
    text-decoration: none;
    text-align: center;
    font-style: oblique;
    font-weight: 600;
    font-family: sans-serif;

    &:hover {
      color: orange;
    }
  }
`;

const LogoImage = styled.div`
  img {
    width: 10vw;
    margin-left: 30%;
    cursor: pointer;

    @media(max-width: 768px) {
      width: 30vw;
      height: 100%;
      min-height: 7vh;
      margin-left: 10%;
    }
    @media(width: 768px) {
      width: 20vw;
    }
  }
`

const LeftMenu = styled.div`
  cursor: pointer;

  a {
    font-size: 15px;
    word-spacing: 20px;
    font-weight: 700;
    text-decoration: none;
    color: black;

    &:hover {
      color: orange;
      font-size: 17px;
    }
  }
  @media(max-width: 768px) {
    display: none;
  }
`;

const PcSearch = styled.div`
  input {
    width: 18vw;
    height: 5vh;
    color: black;
    border-radius: 5px;
    border: 1px solid whitesmoke;

    &:hover {
      border: 1px solid orange;
    }

    @media (min-height: 1085px) {
      height: 4.8vw;
    }
  }
`;

const RightMenu = styled.div`
  width: 18vw;
  display: flex;
  justify-content: space-around;
  align-items: center;

  @media(max-width: 768px) {
    width: 25vw;
  }

  .accounthead {
    @media(max-width: 768px) {
      display: none
    }
  }

  .search {
    @media(max-width: 768px) {
      display: none;
    }
  }

  .menu {
    display: none;
    @media(max-width: 768px) {
      display: inline;
      cursor: pointer;
      &:hover {
        color: orange;
      }
    }
  }

  a, .search {
    color: black;

    &:hover {
      color: orange;
      cursor: pointer;
      font-style: oblique;
    }
  }
`;

export default AdminHeader
